import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import DeleteCardInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import AlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { getCardIconFromContentFul } from '../../utils/myPaymentMethodsUtils';

export const displayAllCardsTemplateJSX = (savedCards, deleteCardPopup, allCardsTypesList) => {
  return (
    <div className='payment-methods-allCardsContainer' data-testid='all-cards-template'>
      {savedCards?.map(card => {
        return singleCardTemplateJSX(card, deleteCardPopup, allCardsTypesList);
      })}
    </div>
  );
};

export const singleCardTemplateJSX = (card, deleteCardPopup, allCardsTypesList) => {
  return (
    <div key={card?.id} className='payment-methods-singleCardContainer'>
      <div className='payment-methods-singleCardContainer-firstRow'>
        <img className='card_icon' src={getCardIconFromContentFul(allCardsTypesList, card?.type)} alt='card-imgage' />
        <span>{card?.maskedCardNumber && `${card?.maskedCardNumber?.replace(/x/gi, '')}`}</span>
        <span data-testid={card?.id} onClick={() => deleteCardPopup(card?.id)}>
          {translateWithI18Next(TRANSLATE_MAPPING_KEY?.DELETE)}
        </span>
      </div>
      {/* Below empty div with className payment-methods-singleCardContainer-secondRow is to display param Nickname on card which is not available in card response  */}
      <div className='payment-methods-singleCardContainer-secondRow'></div>
      {/* Below empty span with className payment-methods-singleCardContainer-thirdRow is to display param Fullname on card which is not available in card response  */}
      <div className='payment-methods-singleCardContainer-thirdRow'>
        <span></span>
        <span>
          {card?.expiryDate &&
            `${translateWithI18Next(TRANSLATE_MAPPING_KEY?.EXP)} ${card?.expiryDate.replace(
              card?.expiryDate.substring(2, 4),
              '/',
            )}`}
        </span>
      </div>
    </div>
  );
};

export const noSavedCardsTextJSX = () => {
  return (
    <div data-testid='no-cards-template'>
      <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.NO_SAVED_CARDS)}</span>
    </div>
  );
};

export const DeleteCardConfirmModal = props => {
  const { handleClose, deleteCardHandler } = props;
  const { DELETE_CARD, CANCEL, CARD_DELETE_CONFIRMATION } = TRANSLATE_MAPPING_KEY;
  const CARD_DELETE_CONSTANTS = {
    CONFIRM_CARD_DELETE_TEXT: {
      MSGTXT1: translateWithI18Next(CARD_DELETE_CONFIRMATION),
    },
  };

  return (
    <React.Fragment>
      <DeleteCardInsideModel
        handleClose={handleClose}
        classNames='delete-account-modal'
        CartAlertForm={
          <AlertForm
            splitTitle={CARD_DELETE_CONSTANTS.CONFIRM_CARD_DELETE_TEXT}
            imageSrc={IMAGE_PATH.PictogramAlertIcon}
            altText={'delete-card'}
            cancelButtonText={translateWithI18Next(CANCEL)}
            confirmButtonText={translateWithI18Next(DELETE_CARD)}
            confirmHandler={deleteCardHandler}
            cancelHandler={handleClose}
          />
        }
      />
    </React.Fragment>
  );
};
